import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-4">
            <span className="text-xs font-label tracking-widest text-primary-700">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              下载与安装常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">
              这里整理了用户在下载安卓版、iOS 版和最新版时最常遇到的情况，点击问题即可展开查看说明。
            </p>

            <div className="mt-6 rounded-lg overflow-hidden border border-background-200">
              <div className="w-full h-[200px] md:h-[240px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20friendly%20green%20frog%20character%20holding%20a%20smartphone%20with%20speech%20bubbles%20around%20it%2C%20warm%20cream%20background%20with%20soft%20accents%2C%20calm%20clean%20modern%20minimal%20style%2C%20subtle%20shadows%2C%20cozy%20welcoming%20atmosphere%2C%20high%20detail&width=900&height=900&seq=manwa-faq-01&orientation=squarish"
                  alt="漫画阅读客户端帮助说明示意图"
                  title="漫蛙客户端使用帮助"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <li key={faq.q} className="rounded-lg border border-background-200 bg-background-100/60 overflow-hidden">
                    <h3>
                      <button
                        type="button"
                        onClick={() => toggle(index)}
                        aria-expanded={isOpen}
                        aria-controls={`faq-panel-${index}`}
                        className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                      >
                        <span className="text-sm md:text-base font-medium text-foreground-950">{faq.q}</span>
                        <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0">
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div id={`faq-panel-${index}`} className="px-4 md:px-5 pb-4 -mt-1">
                        <p className="text-sm leading-7 text-foreground-600">{faq.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}